
import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { UserRole } from '@/types';
import { Loader2 } from 'lucide-react';

interface AuthGuardProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children, allowedRoles = [] }) => {
  const { user, profile, loading } = useAuth();

  useEffect(() => {
    console.log("AuthGuard: User:", user?.id);
    console.log("AuthGuard: Profile:", profile);
    console.log("AuthGuard: Loading:", loading);
    console.log("AuthGuard: Allowed Roles:", allowedRoles);
  }, [user, profile, loading, allowedRoles]);

  if (loading) {
    return (
      <div className="flex h-screen w-full items-center justify-center">
        <Loader2 className="h-10 w-10 animate-spin text-royalty-600" />
      </div>
    );
  }

  if (!user) {
    console.log("AuthGuard: Not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles.length > 0 && profile) {
    if (!allowedRoles.includes(profile.role)) {
      console.log(`AuthGuard: User role ${profile.role} not in allowed roles, redirecting`);
      // Redirect based on user role
      if (profile.role === 'admin') {
        return <Navigate to="/admin/dashboard" replace />;
      } else {
        return <Navigate to="/author/dashboard" replace />;
      }
    }
  }

  console.log("AuthGuard: Access granted");
  return <>{children}</>;
};

export default AuthGuard;
